module.exports = __webpack_public_path__ + "static/homepage-hero-img-af7d681836ea52180106ad4be028c9ac.svg";